import type { UserRole } from '@/types'

/** Default page size for paginated lists. */
export const DEFAULT_PAGE_SIZE = 10

/** Maximum `limit` for GET /users (backend rejects values above this). */
export const USERS_API_MAX_LIMIT = 100

/** All user roles. */
export const ROLES: UserRole[] = ['staff', 'manager', 'hr', 'admin']

/** Storage key for persisted auth. */
export const AUTH_STORAGE_KEY = 'staff-portal-auth'
